/** @format */
import { css } from 'styled-components';

import { CriteriaListProps } from './index';

/**
 * Base styles for the CriteriaList component
 */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    padding-left: 0;

    h3 {
        display: inline;
        margin-right: 1.2rem;
        color: var(--colors-text-secondary);
    }

    .criteria-box {
        margin: 0 0.8rem 0.8rem 0;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The CriteriaList component styles
 *
 * @param {CriteriaListProps} props The criteria-list properties object
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
export const styles = (props: CriteriaListProps) => css`
    ${baseStyles()}
`;
